import React, { useEffect } from 'react'
import StudentSidebar from '../StudentSidebar/StudentSidebar'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getWebsiteSettingData } from '../../../Redux/action/MasterAction'

const StudentContactUs = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getWebsiteSettingData());
    }, [])

    const {
        loadingWebsiteSettingDataListApi,
        WebsiteSettingDataListApiData,
        WebsiteSettingDataListApiError

    } = useSelector(state => state?.MasterReducer);
    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Contact Us
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="row">
                                    <div className="col-lg-12 d-flex align-items-center justify-content-center">
                                        <img
                                            src="https://tse2.mm.bing.net/th?id=OIP.lpdwrxp78JIWMumGLRyyeAHaE7&pid=Api&P=0&h=380"
                                            alt=""
                                            className="img-fluid"
                                        />
                                    </div>
                                </div>
                                <h4 className="text-center">Get Support</h4>
                                <p className="text-center mt-3" style={{ fontSize: 18 }}>
                                {" "}
                                    Facing any issues with the platform? We're here to help! Whether it's a technical glitch, account-related concern, or any other platform-related query, reach out to us, and our support team will assist you{" "}
                                </p>
                                <div
                                    className="d-flex m-auto padding"
                                    style={{ justifyContent: "center", gap: 20 }}
                                >
                                    <a href={`mailto:${WebsiteSettingDataListApiData?.email}?subject=Support Request`}>
                                        <button className="btn btn-primary">Mail Us Now</button>
                                    </a>
                                    <a href={`tel:${WebsiteSettingDataListApiData?.mobile}`}>
                                        <button className="btn btn-primary">Call Us Now</button>
                                    </a>

                                </div>
                            </main>



                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default StudentContactUs